<template>
  <div class="supervision_course_container">
    <div class="supervision_course_container_header">
      <!-- 左边的状态以及时间的展示： -->
      <div class="supervision_course_container_header_status_and_time">
        <picture-header-for-status
          :liveClassShareLiveInfo="liveClassShareLiveInfo"
          :liveDetailInfoForApp="liveDetailInfoForApp"
        ></picture-header-for-status>
      </div>
      <!-- 中间的头： -->
      <div class="supervision_course_container_header_title_module">
        <img
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/35556b7fa3124c9dba30a35274d4135d.png"
          alt="同步课堂网督学中心"
        />
        <!-- <div class="supervision_course_container_header_title_module_top">
          <div
            class="supervision_course_container_header_title_module_top_inner"
          >
            <div
              class="supervision_course_container_header_title_module_top_img"
            >
              <img
                src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/d82cf0e15008449d99e3ec273f50f5c5.png"
                alt="logo"
              />
            </div>
            <div
              class="supervision_course_container_header_title_module_top_text"
            >
              <span>同步课堂网</span>
              <span>督学中心</span> -->
              <!-- TODO: mock -->
              <!-- <a-button @click="test(1)">T</a-button>
              <a-button @click="test(2)">TS</a-button>
              <a-button @click="test(3)">TV</a-button>
              <a-button @click="test(4)">V</a-button> -->

              <!-- 测试指令 -->
              <!-- <a-button @click="test2()"> 测试指令 4006 </a-button> -->
            <!-- </div>
          </div>
        </div>
        <div class="supervision_course_container_header_title_module_bottom">
          <div class="line"></div>
        </div> -->
      </div>
      <!-- 右边的网络状态： -->
      <div class="supervision_course_container_header_right_module">
        <!-- 网络状态： -->
        <!-- <network-info-of-status
          @lookForNetworkInfo="lookForNetworkInfo"
          :networkInfoStatus="networkInfoStatus"
          v-show="liveStatus == 1 && networkInfoStatus"
        /> -->
        <network-info-of-status
          @lookForNetworkInfo="lookForNetworkInfo"
          :networkInfoStatus="networkInfoStatus"
          :onNetworkQualityArr="onNetworkQualityArr"
          :networkInfoShow="networkInfoShow"
          :networkQualityStyle="{
            width: '200px',
            top: '30px',
            left: '-160px'
          }"
        />
      </div>
    </div>
    <!-- 视频部分 -->
    <div class="supervision_course_container_body">
      <!-- 主视频 -->
      <div class="supervision_course_container_body_left">
        <!-- 课件画面： -->
        <div
          class="supervision_course_container_body_left_inner_for_screen_stream"
          :style="{ zIndex: lookForCourseScreen ? 1 : 0 }"
        >
          <video src="" id="idForCourseScreenOnLeft" autoplay muted></video>
          <!-- <div class="play_explain_for_box" style="color: #fb6f33"> -->
          <div class="play_explain_for_box">
            课件画面(主讲)
          </div>
        </div>
        <!-- 教室画面： -->
        <div
          :style="{ zIndex: lookForCourseScreen ? 0 : 1 }"
          :class="[
            'supervision_course_container_body_left_inner_for_class_of_outer',
          ]"
        >
          <div
            class="supervision_course_container_body_left_inner_for_class_of_outer_video"
            v-show="liveStatus == 0 || liveStatus == 1"
          >
            <video
              id="LCVideoMainLeft"
              ref="LCVideoMainLeft"
              :src="mainVideos[0]"
              autoplay
              :style="{
                objectFit:
                  nowModel == 'TV' && currentScreenModel == 'viceTeacher'
                    ? 'cover'
                    : 'contain',
              }"
            ></video>
          </div>
          <div
            class="supervision_course_container_body_left_inner_for_class_of_outer_video"
            :style="theWidthIsMainAndJudgeModel"
            v-show="liveStatus == 0 || liveStatus == 1"
            ref="LCVideoMainRightBox"
          >
            <video
              id="LCVideoMainRight"
              ref="LCVideoMainRight"
              :src="mainVideos[0]"
              autoplay
              muted
            ></video>
          </div>
          <!-- <div
            class="play_explain_for_box"
            :style="{
              color: currentPlayItem ? '#FB6F33' : '#FFF',
            }"
          > -->
          <div
            class="play_explain_for_box"
            :style="{
              color: currentPlayItem ? '#FFF' : '#FFF',
            }"
          >
            {{ currentPlayItem ? currentPlayItem.className : '- -'
            }}{{
              currentPlayItem
                ? `(${currentPlayItem.role == 1 ? '主讲' : '听课'})`
                : ''
            }}
          </div>
          <div class="video_empty_container" v-show="liveStatus != 0 && liveStatus != 1">
            <span class="iconfont icon-zanwuxinxi"></span>
            <span>{{ liveStatus | disposeLiveStatus }}</span>
          </div>
        </div>

        <!-- 网络信息： -->
        <!-- <div class="data_on_network_quality_container" v-if="networkInfoShow">
          <div class="data_on_network_quality_container_inner_title">网络指标信息</div>
          <div class="data_on_network_quality_container_inner_item" v-for="item in onNetworkQualityArr" :key="item.key">
            {{`${item.key}--${item.title}--${item.value}${item.unit ? ('--' + item.unit) : ''}`}}
          </div>
          <div class="data_on_network_quality_container_null" v-if="!onNetworkQualityArr.length">
            暂无相关信息
          </div>
        </div> -->

        <!-- 调整机位： -->
        <vidicon-control v-if="activeForOperationItem === 'adjust'" :currentPlayItem="currentPlayItem" :clientForZRTC="clientForZRTC" />
      </div>
      <!-- 右侧 分视频 -->
      <div
        class="supervision_course_container_body_right"
        v-show="liveStatus == 0 || liveStatus == 1"
      >
        <!-- 右侧栏与视频相关： -->
        <div class="supervision_course_container_body_right_for_video" :style="{ alignItems: stuVideoAndAudioStreamList.filter(v => v.type != 'audio').length > 1 ? 'flex-start' : 'center' }">
          <div class="supervision_course_container_body_right_inner">
            <!-- 教室画面：主讲：这里产品要求主讲一定要放第一个 -->
            <div
              :class="[
                'supervision_course_container_body_right_inner_item',
                currentScreenModel == 'viceTeacher' ? 'active' : '',
                'ZHIHUISHU_QZMD',
              ]"
              @click="selectCurrentScreen('viceTeacher')"
              style="display: flex;"
            >
              <div
                class="supervision_course_container_body_right_inner_item_for_video"
              >
                <video
                  ref="LCVideoViceLeft"
                  :src="mainVideos[0]"
                  autoplay
                  muted
                  :style="{objectFit: 'fill'}"
                ></video>
              </div>
              <div
                class="supervision_course_container_body_right_inner_item_for_video"
                :style="theWidthIsViceAndJudgeModel"
              >
                <video
                  ref="LCVideoViceRight"
                  :src="mainVideos[0]"
                  autoplay
                  muted
                  :style="{objectFit: 'fill'}"
                ></video>
              </div>
              <div
                class="play_explain_for_box"
                :style="{
                  color: currentScreenModel == 'viceTeacher' ? '#FFF' : '#FFF',
                }"
              >
                <span>{{ (teaVideoAudioRoomList[0] || {}).className }}(主讲)</span>
                <microphone-icon v-if="whoIsSpeaking.includes((teaVideoAudioRoomList[0] || {}).roomId)" :barHeightForAudio="barHeightForAudio" />
              </div>
            </div>
            <!-- 课件画面：（有课件才会展示） -->
            <div
              :class="[
                'supervision_course_container_body_right_inner_item',
                currentScreenModel == 'course' ? 'active' : '',
                'ZHIHUISHU_QZMD',
              ]"
              @click="selectCurrentScreen('course')"
            >
              <div
                class="supervision_course_container_body_right_inner_item_for_video course_screen_in_list_on_right_outer"
              >
                <video
                  src=""
                  id="courseScreenRight"
                  ref="courseScreenRight"
                  autoplay
                  muted
                  :style="{objectFit: 'fill'}"
                ></video>
              </div>
              <!-- <div class="play_explain_for_box" style="color: #fb6f33"> -->
              <div class="play_explain_for_box" style="color: #FFF">
                课件画面(主讲)
              </div>
            </div>
            <audio
              id="LCAudio"
              ref="LCAudio"
              volume="true"
              controls
              autoplay
              v-show="false"
            ></audio>
            <!-- 收视教室画面 收视教室可能有多个 这是列表 -->
            <div
              :class="[
                'supervision_course_container_body_right_inner_item',
                currentScreenModel == 'viceStudent' && viceIndex == index
                  ? 'active'
                  : '',
                'ZHIHUISHU_QZMD',
              ]"
              v-for="(item, index) in stuVideoAndAudioStreamList"
              v-show="item.type != 'audio'"
              :key="index"
              @click="selectCurrentScreen('viceStudent', index, item)"
            >
              <div
                class="supervision_course_container_body_right_inner_item_for_video"
              >
                <video
                  :ref="`LCVideoViceRating${index}`"
                  :src="mainVideos[0]"
                  autoplay
                  muted
                  :style="{objectFit: 'fill'}"
                ></video>
              </div>
              <div
                class="play_explain_for_box"
                :style="{
                  color:
                    currentScreenModel == 'viceStudent' && viceIndex == index
                      ? '#FFF'
                      : '#FFF',
                }"
              >
                <span>{{ getStuInfoByStream(item).className }}(听课)</span>
                <microphone-icon v-if="whoIsSpeaking.includes(getStuInfoByStream(item).roomId)" :barHeightForAudio="barHeightForAudio" />
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧栏与详情相关： -->
        <template v-if="activeForOperationItem === 'classroom'">
          <div class="live_detail_container">
            <div class="live_detail_container_title">直播+教室详情</div>
            <div class="live_detail_container_base_info">
              <div class="live_detail_container_base_info_title">基本信息</div>
              <div class="live_detail_container_base_info_body">
                <div
                  class="live_detail_container_base_info_body_item"
                  v-for="item in objectOfLCDetail.detailInfoList"
                  :key="item.title"
                >
                  <div class="live_detail_container_base_info_body_item_title">
                    【{{ item.title }}】：
                  </div>
                  <div class="live_detail_container_base_info_body_item_body">
                    <a-tooltip placement="topLeft" :overlayStyle="{width: 'auto'}">
                      <template slot="title">
                        <span>{{item.firstValue ? item.firstValue : '- -'}}</span>
                        <span v-if="item.hasOwnProperty('secondValue')">（{{item.secondValue ? item.secondValue : '- -'}}）</span>
                      </template>
                      <span :class="['first_value']">{{
                        item.firstValue ? item.firstValue : '- -'
                      }}</span>
                      <span
                        class="second_value"
                        v-if="item.hasOwnProperty('secondValue')"
                        >（{{
                          item.secondValue ? item.secondValue : '- -'
                        }}）</span
                      >
                    </a-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="live_detail_container_for_teacher">
              <div class="live_detail_container_for_teacher_title">
                主讲
              </div>
              <div class="live_detail_container_for_teacher_body" v-if="teacherRoomNum">
                <div
                  class="body_item"
                  v-for="item in objectOfLCDetail.roomList"
                  :key="item.roomName"
                  v-show="item.roomType === 1"
                >
                  <div class="body_item_title">
                    {{ item.roomName }}
                  </div>
                  <div class="body_item_body">
                    <div class="body_item_body_management">
                      <span class="person_type"
                        >{{
                          item.classType ? '【导播】' : '【管理员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.adminName ? item.adminName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.adminPhone ? item.adminPhone : '- -'
                        }}）</span
                      >
                    </div>
                    <div class="body_item_body_maintain">
                      <span class="person_type"
                        >{{
                          item.classType ? '【专员】' : '【维护员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.defendName ? item.defendName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.defendPhone ? item.defendPhone : '- -'
                        }}）</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="live_detail_container_for_teacher_body_empty" v-if="!teacherRoomNum">
                抱歉，暂无教室哦
              </div>
            </div>
            <div class="live_detail_container_for_student">
              <div class="live_detail_container_for_student_title">
                听课（{{ watchRoomNum }}）
              </div>
              <div class="live_detail_container_for_student_body" v-if="watchRoomNum">
                <div
                  class="body_item body_item_for_student"
                  v-for="item in objectOfLCDetail.roomList"
                  :key="item.roomName"
                  v-show="item.roomType === 2"
                >
                  <div class="body_item_title">
                    {{ item.roomName }}
                  </div>
                  <div class="body_item_body">
                    <div class="body_item_body_management">
                      <span class="person_type"
                        >{{
                          item.classType ? '【导播】' : '【管理员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.adminName ? item.adminName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.adminPhone ? item.adminPhone : '- -'
                        }}）</span
                      >
                    </div>
                    <div class="body_item_body_maintain">
                      <span class="person_type"
                        >{{
                          item.classType ? '【专员】' : '【维护员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.defendName ? item.defendName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.defendPhone ? item.defendPhone : '- -'
                        }}）</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="live_detail_container_for_student_body_empty" v-if="!watchRoomNum">
                抱歉，暂无教室哦
              </div>
            </div>
          </div>
        </template>
        <!-- 右侧与文字互动相关： -->
        <template v-if="activeForOperationItem === 'textInteraction'">
          <div class="textInteraction_container">
            <chat-room />
          </div>
        </template>
      </div>
      <!-- 右侧装饰块，只有详情和聊天室展示这个： -->
      <div class="supervision_course_container_body_right_top_module" v-if="activeForOperationItem === 'classroom' || activeForOperationItem === 'textInteraction'"></div>
    </div>
    <div class="supervision_course_container_footer">
      <div class="supervision_course_container_footer_left_for_name">
        {{
          liveClassShareLiveInfo && liveClassShareLiveInfo.liveName
            ? liveClassShareLiveInfo.liveName
            : '- -'
        }}
      </div>
      <div class="supervision_course_container_footer_right_for_operation">
        <div
          :class="[
            'supervision_course_container_footer_right_for_operation_item ZHIHUISHU_QZMD',
            activeForOperationItem === item.key ? 'active' : '',
            item.disabled ? 'class_for_disabled' : ''
          ]"
          v-for="item in operationList"
          :key="item.title"
          @click.stop="operationOfClickButton(item)"
        >
          <img v-if="getIsHaveNewMsg && item.key == 'textInteraction'" class="iconfont_icon" src="../../assets/img/icon_student_web.png" :alt="item.title" />
          <img v-else class="iconfont_icon" :src="item.img" :alt="item.title" />
          <span class="iconfont_text" :style="{ color: item.color }"
            >{{ item.title
            }}<span v-if="item.key === 'classroom'"
              >({{ Number(watchRoomNum) + Number(teacherRoomNum) }})</span
            >
          </span>
        </div>
      </div>
    </div>

    <!-- lc  detail： -->
    <!-- <detail-by-liveId
      title="直播+教室详情"
      @hideMaskForLCDetail="hideMaskForLCDetail"
      :dialogFlagForLCDetail="dialogFlagForLCDetail"
      :objectOfLCDetail="objectOfLCDetail"
      :teacherRoomNum="teacherRoomNum"
      :watchRoomNum="watchRoomNum"
      :dialogLoadingForLCDetail="dialogLoadingForLCDetail"
    ></detail-by-liveId> -->

    <!-- 终止直播： -->
    <my-dialog
      @hideMask="hideMaskForStopLiveCourse"
      :dialogFlag="dialogFlagForStopLiveCourse"
      width="396px"
      p_lr="0"
      borderRadius="8px"
      :hideMaskFlag="false"
    >
      <div class="dialog_inner_container_for_stop_live_course">
        <div class="dialog_inner_container_for_stop_live_course_header">
          终止直播！
        </div>
        <div class="dialog_inner_container_for_stop_live_course_body">
          <div class="dialog_inner_container_for_stop_live_course_body_title">
            确认要“终止直播”么？终止后，所有听课教室将无法继续听课，如有问题可先联系“智慧树”客服
          </div>
          <div
            :class="[
              'dialog_inner_container_for_stop_live_course_body_content',
              'animate__animated',
              stopReasonHasAnimateShakeX ? 'animate__shakeX' : '',
            ]"
          >
            <textarea
              type="textarea"
              v-model="stopReason"
              placeholder="请输入强行终止直播的原因，如课堂涉黄、涉恐等..."
            ></textarea>
          </div>
        </div>
        <div class="dialog_inner_container_for_stop_live_course_footer">
          <div
            :class="[
              'dialog_inner_container_for_stop_live_course_footer_inner_item',
              stopLiveCourseOperationItem.className,
              'ZHIHUISHU_QZMD',
            ]"
            v-for="stopLiveCourseOperationItem in stopLiveCourseOperationList"
            :key="stopLiveCourseOperationItem.title"
            :style="{
              backgroundColor: stopLiveCourseOperationItem.bgc,
              border: stopLiveCourseOperationItem.border,
              color: stopLiveCourseOperationItem.color,
            }"
            @click="operationForStopLiveCourseItem(stopLiveCourseOperationItem)"
          >
            {{ stopLiveCourseOperationItem.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForStopLiveCourse">
          <a-spin />
        </div>
      </div>
    </my-dialog>

    <!-- 播放按钮： -->
    <play-button @operationForPlay="operationForPlay" v-if="autoPlayError" />
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import LivePlayer from '@liveqing/liveplayer'
import DateUtil from '../../utils/getDate.js'
import { getRandomNumber, getNameTextForEnumeration } from '../../utils/tool'
import Agora from '../../utils/agora'
import { hintByliveStatusOptions } from '../../utils/enumerate'

export default {
  name: 'LCSupervisionCourse',
  components: {
    'live-player': LivePlayer,
    'detail-by-liveId': () => import('../../components/componentsForPage/detail_by_liveId'),
    'my-dialog': () => import('../../components/my_dialog'),
    'picture-header-for-status': () => import('../../components/componentsForPage/picture_header_for_status'),
    'network-info-of-status': () => import('../../components/networkInfoOfStatus/index.vue'),
    'vidicon-control': () => import('../../components/vidiconControl/index.vue'),
    'microphone-icon': () => import('../../components/microphoneIcon/index.vue'),
    'chat-room': () => import('../../components/chatRoom/index.vue'),
    'play-button': () => import('../../components/playButton/index.vue')
  },
  data() {
    return {
      // 直播详情：
      liveClassShareLiveInfo: null,
      lcId: '',
      // 播放相关：
      videoList: [],
      currentPlayItem: null,
      // 底部操作按钮：
      operationList: [
        {
          title: '教室',
          icon: 'icon-caiyouduo_hemaixiangqing-fanganxiangqing',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/33136bf13cc44d28b0202cd9a64f7e4f.png',
          key: 'classroom',
          color: '#FFF',
          disabled: false
        },
        {
          title: '调整机位',
          icon: '',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/20c97caea47a443e87fb7df90a590137.png',
          key: 'adjust',
          color: '#FFF',
          disabled: false
        },
        {
          title: '文字互动',
          icon: '',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/d7dcf58dbec84b3bb6107403625a8184.png',
          key: 'textInteraction'
        },
        {
          title: '终止直播',
          icon: 'icon-zuizhongchuqu',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/fba5009825f749a7af2f1b860fbfdcc2.png',
          key: 'termination',
          color: '#FFF',
          disabled: false
        },
      ],
      activeForOperationItem: '',
      // lc detail:
      // dialogFlagForLCDetail: false,
      objectOfLCDetail: {
        detailInfoList: [
          {
            title: '课程',
            firstValue: '',
            secondValue: '',
            secondColor: '#669CFF',
          },
          {
            title: '类型',
            firstValue: '同步课堂',
            secondValue: '',
            secondColor: '##474C59',
          },
          {
            title: '主讲',
            firstValue: '',
            secondValue: '',
            secondColor: '#669CFF',
          },
          {
            title: '时间',
            firstValue: '',
          },
        ],
        roomList: [],
      },
      dialogLoadingForLCDetail: false,
      // 终止直播：
      stopReason: '',
      stopReasonHasAnimateShakeX: false,
      dialogFlagForStopLiveCourse: false,
      stopLiveCourseOperationList: [
        {
          title: '继续终止',
          bgc: 'transparent',
          border: '1px solid #858688',
          color: '#FAFAFA',
          className: 'stop_live_course_continue',
        },
        {
          title: '撤销操作',
          bgc: '#3982FF',
          border: 'none',
          color: '#FFF',
          className: 'stop_live_course_cancel',
        },
      ],
      dialogLoadingForStopLiveCourse: false,
      // 共享屏幕：
      myAgora: null,
      agorartcInfo: null,
      role: 1, // 主讲助教：1主讲2助教
      isJoined: false, // 判断是否拿到课件流
      // 左侧课件的展示与播放：
      lookForCourseScreen: false,
      // 右侧课件画面是否展示：
      showForCourseScreenInListOnRight: false,
      // 左侧教室的切换优化：
      livePlayerShow: true,
      // new 逻辑
      // 1 一个 2,T+S,两个对半分 3.T+V 老师课件 1:2
      mainVideos: [],
      // 接入LC督学
      liveId: '',
      liveDetailInfo: {},
      AbleRTC: new Map(), //实例Map
      classroomId: '',
      stateMachineArr: {}, //状态机数据对象
      speakRoomCode: '', //主讲教室id
      agaroIdArr: [], // 声网订阅流id
      lastagaroIdArr: [], // 上一次已订阅的流id数组
      nowModel: 'T', // 当前模式
      nowSpeaker: 'main', // 当前演讲者
      teaVideoAudioRoomList: [], // 主讲订阅列表
      stuVideoAudioRoomList: [], // 收视订阅列表
      teaVideoAndAudioStreamList: [], // 主讲音视频流订阅
      stuVideoAndAudioStreamList: [], // 收视音视频流订阅
      currentScreenModel: 'viceTeacher',
      viceIndex: 0, // 收视教室激活key值
      pageIsInit: true,
      totalAudioStream: '', // 音频合流
      currentStuRoomId: '', // 互动教室id 用于判断TS模式下 s该显示哪路流
      // 指标展示：
      networkInfoShow: false,
      // 及时更新的：
      onNetworkQualityObjStatus: '',
      onNetworkQualityArrOrigin: [
        // {
        //   key: 'RecvBitrate',
        //   value: '',
        //   title: '音视频总接收码率（Kbps），瞬间值',
        //   unit: 'Kbps'
        // },
        // {
        //   key: 'RecvBytes',
        //   value: '',
        //   title: '接收字节数，累计值',
        //   unit: ''
        // },
        // {
        //   key: 'SendBitrate',
        //   value: '',
        //   title: '音视频总发送码率（Kbps），瞬间值',
        //   unit: 'Kbps'
        // },
        // {
        //   key: 'SendBytes',
        //   value: '',
        //   title: '发送字节数，累计值',
        //   unit: ''
        // }
        // 20220525add:暂时不展示上面的信息
        {
          key: 'End2EndDelay',
          value: '',
          title: '延迟',
          unit: 'ms'
        },
        {
          key: 'PacketLossRate',
          value: '',
          title: '丢包率',
          unit: '%'
        }
      ],
      // 间隔更新的：
      networkInfoStatus: '',
      onNetworkQualityArr: [],
      // 麦克风音量：
      barHeightForAudio: '0%',
      // 谁在说话：
      whoIsSpeaking: [],
      // 针对自动播放：
      autoPlayError: false,
      clientForZRTC: null,
      // 后面新增的详情：
      liveDetailInfoForApp: null
    }
  },
  filters: {
    disposeLiveStatus: function (liveStatus) {
      return getNameTextForEnumeration(hintByliveStatusOptions, liveStatus)
    },
  },
  watch: {
    // nowModel(val, oldVal) {
    //   this.modelChange()
    // },
    currentPlayItem: function (newval) {
      let flagForDisabled = false
      if (newval) {
        if (newval.roomId) {
          if (newval.roomId.includes('SIMPLE')) {
            flagForDisabled = false
          } else {
            flagForDisabled = true
          }
        } else {
          flagForDisabled = true
        }
      } else {
        flagForDisabled = true
      }
      this.disposeForAdjustDisabled(flagForDisabled)
    }
  },
  computed: {
    ...mapGetters('userInfo', ['userId']),
    ...mapGetters('imCommunication', ['getLeftBarName', 'getIsHaveNewMsg']),
    // 当前是否是主讲或者主讲共享屏幕
    isLecturer() {
      return (
        this.currentScreenModel == 'viceTeacher' ||
        this.currentScreenModel == 'course'
      )
    },
    theWidthIsMainAndJudgeModel() {
      // 判断是否是主讲教室并且是双模式还是三模式
      if (
        this.nowSpeaker == 'main' &&
        this.currentScreenModel == 'viceTeacher'
      ) {
        if (this.nowModel == 'TS') {
          return 'width: 50%'
        } else if (this.nowModel == 'TV') {
          return 'width: 75%'
        } else {
          return 'width: 0%'
        }
      } else {
        return 'width: 0%'
      }
    },
    theWidthIsViceAndJudgeModel() {
      // 判断是否是主讲教室并且是双模式还是三模式
      if (this.nowSpeaker == 'main') {
        if (this.nowModel == 'TS') {
          return 'width: 50%'
        } else if (this.nowModel == 'TV') {
          return 'width: 75%'
        } else {
          return 'width: 0%'
        }
      } else {
        return 'width: 0%'
      }
    },
    // 直播详情：有几间收视教室
    watchRoomNum() {
      return this.objectOfLCDetail.roomList.filter(
        (item) => item.roomType === 2
      ).length
    },
    teacherRoomNum() {
      return this.objectOfLCDetail.roomList.filter(
        (item) => item.roomType === 1
      ).length
    },
    liveStatus() {
      let num = -3
      if (this.liveClassShareLiveInfo) {
        let { status } = this.liveClassShareLiveInfo
        num = status
      }
      return num
    },
  },
  async created() {
    try {
      let { liveId } = this.$route.query
      this.liveId = liveId
      if (!liveId) return this.$router.go(-1)
      window.addEventListener('resize', (e) => {
        this.listenResize(e)
      })
      await this.liveClassShareLive()
      await this.getLiveDetail()
      this.liveDetailInfoForApp = await this.getLiveDetailForAPP(this.liveId)
      await this.getAgaroToken()
      await this.connectIm()

      // 混合模式加入SDK房间获取在麦状态：
      // 20220608 add start：
      this.getMicStatus()
      // 20220608 add end
      
      this.getLCDetail(this.$route.query.liveId)
    } catch (err) {
      console.log(err)
    }
  },
  mounted () {
    // 应产品要求，每5秒钟更新一次网络监测信息：
    const timerIdForUpdateNetworkInfo = setInterval(() => {
      this.onNetworkQualityArr = JSON.parse(JSON.stringify(this.onNetworkQualityArrOrigin))
      this.networkInfoStatus = this.onNetworkQualityObjStatus
    }, 5000)
    this.$once('hook:beforeDestroy', () => {
      timerIdForUpdateNetworkInfo && clearInterval(timerIdForUpdateNetworkInfo)
    })
  },
  methods: {
    ...mapMutations('userInfo', {
      Mutation_SET_USERID: 'Mutation_SET_USERID',
    }),
    ...mapMutations('imCommunication', {
      addIMMsg: 'addIMMsg',
      setIsHaveNewMsg: 'setIsHaveNewMsg',
      setRoleList: 'setRoleList'
    }),
    ...mapActions('imCommunication', {
      getImConfigInfo: 'getImConfigInfo',
      webImInit: 'webImInit',
    }),
    test2() {
      let a = {
        data: {
          actionType: 1,
          userName: '10楼主讲',
          interactModel: 'TS',
          path: ['500855772225'],
        },
        from: '1875016186',
        id: 'abcb5ed9-13f6-458c-b2e6-e3fb5740057b',
        lcId: '14867',
        to: '758056193',
        type: '4006',
      }
      this.disposeMessage(a)
    },
    test(type) {
      // mock 切换模式
      switch (type) {
        case 1:
          {
            this.nowModel = 'T'
          }
          break
        case 2:
          {
            this.nowModel = 'TS'
          }
          break
        case 3:
          {
            this.nowModel = 'TV'
          }
          break
        case 4:
          {
            this.nowModel = 'V'
          }
          break
      }
    },
    listenResize(e) {
      if (this.nowModel == 'TV') {
        this.setMainLeftTVHeight()
      } else {
      }
    },
    /**
     * 新加 LC接入督学中心
     */
    // 根据流筛选收视信息 感觉流跟信息分开 好sapi啊
    getStuInfoByStream(stream) {
      let info =
        this.stuVideoAudioRoomList.find((item) => {
          let streamTypeArr = stream.streamType.split('/') || []
          let roomId = streamTypeArr.length
            ? streamTypeArr[streamTypeArr.length - 1]
            : ''
          return item.roomId == roomId
        }) || {}
      return info
    },
    /**
     * @description: 获取直播详情
     * @param {*}
     * @return {*}
     */
    async getLiveDetail() {
      let res = await this.$http.getLiveDetail({
        liveId: this.liveId,
      })
      if (res.rt.resultStatus == -1 || res.code != 200) {
        return this.$message.error(res.rt.resultMessage)
      }
      this.liveDetailInfo = res.rt.liveInfo || {}
      this.classroomId = this.liveDetailInfo.liveCourseId || ''
    },
    /**
     * @description: 获取声网Token  classroomId: liveCourseID
     * @param {*}
     * @return {*}
     */
    async getAgaroToken() {
      // 张颖的接口：
      // let res = await this.$http.getAgaroToken({
      //   classroomId: this.classroomId,
      //   listChannels: [
      //     {
      //       identifier: getRandomNumber(6),
      //       channelId: this.classroomId,
      //     },
      //   ],
      // })
      // if (res.data?.rt?.resultStatus == -1 || res.status != 200) {
      //   return this.$message.error(
      //     res.data.rt?.resultMessage || '获取Token失败'
      //   )
      // }
      // this.getTokenAndChannel = res.data.rt
      // 皮腾的接口：
      let res = await this.$http.agoraGetSubscribToken({
        uuid: getRandomNumber(6),
        channelId: this.classroomId,
        channelIds: this.classroomId
      })
      if (res.rt.resultStatus !== 1) {
        return this.$message.error(
          res.rt?.resultMessage || '获取Token失败'
        )
      }
      this.getTokenAndChannel = res.rt

      // console.log('获取声网Token成功:', res)
      await this.getStateMachine()
      // 初始化声网
      this.agaroInit()
    },
    /**
     * @description: 初始化声网
     * @param {*}
     * @return {*}
     */
    async agaroInit() {
      let options = {
        appId: this.getTokenAndChannel.appId,
        token: this.getTokenAndChannel.data[0].token,
        channelId: this.getTokenAndChannel.data[0].channelId,
        userId: this.getTokenAndChannel.data[0].userId,
      }
      // console.log('初始化声网', options)
      let agora = new Agora(options, this.role)
      agora.agoraInit()
      this.AbleRTC.set(this.classroomId, agora) //保存声网实例
      agora.watchStreamSubscribed((e) => {
        console.log('收到流：', e)
        this.showStream(e)
      })

      let updateCount = 0
      let updateCountForGetRemoteVideoStats = 0
      // 获取网络相关数据：
      this.timerIdFoGetSessionStats = setInterval(() => {
        agora.getSessionStats(stats => {
          // old:
          // this.onNetworkQualityArrOrigin = this.onNetworkQualityArrOrigin.map(item => {
          //   console.log(stats, 'stats')
          //   const { key } = item
          //   switch (key) {
          //     case 'RecvBitrate':
          //       {
          //         item.value = stats[key] ? stats[key] : 0
          //         const recvBitrateCount = Number(stats[key])
          //         if (!recvBitrateCount) {
          //           this.onNetworkQualityObjStatus = '断网'
          //         }
          //         if (recvBitrateCount && (recvBitrateCount <= 200)) {
          //           this.onNetworkQualityObjStatus = '差'
          //         }
          //         if ((recvBitrateCount > 200) && (recvBitrateCount <= 600)) {
          //           this.onNetworkQualityObjStatus = '良'
          //         }
          //         if (recvBitrateCount > 600) {
          //           this.onNetworkQualityObjStatus = '优'
          //         }
          //       }
          //       break
          //     default:
          //       item.value = stats[key] ? stats[key] : 0
          //       break
          //   }
          //   return item
          // })
          // new:
          const recvBitrateCount = Number(stats['RecvBitrate'])
          if (!recvBitrateCount) {
            this.onNetworkQualityObjStatus = '断网'
          }
          if (recvBitrateCount && (recvBitrateCount <= 200)) {
            this.onNetworkQualityObjStatus = '差'
          }
          if ((recvBitrateCount > 200) && (recvBitrateCount <= 600)) {
            this.onNetworkQualityObjStatus = '良'
          }
          if (recvBitrateCount > 600) {
            this.onNetworkQualityObjStatus = '优'
          }

          // 以下只更新一次：
          if (updateCount === 0) {
            updateCount++
            // this.onNetworkQualityArr = JSON.parse(JSON.stringify(this.onNetworkQualityArrOrigin))
            this.networkInfoStatus = this.onNetworkQualityObjStatus
          }
        })
        agora.getRemoteVideoStats(remoteVideoStatsMap => {
          const remoteVideoStatsList = Object.values(remoteVideoStatsMap || {})
          let end2EndDelayTotal = 0
          let packetLossRateTotal = 0
          remoteVideoStatsList.forEach(item => {
            end2EndDelayTotal += Number(item.End2EndDelay || 0)
            packetLossRateTotal += Number(item.PacketLossRate || 0)
          })
          let remoteVideoStatsObj = {
            End2EndDelay: remoteVideoStatsList.length ? (end2EndDelayTotal / remoteVideoStatsList.length).toFixed(0) : 0,
            PacketLossRate: remoteVideoStatsList.length ? (packetLossRateTotal / remoteVideoStatsList.length).toFixed(0) : 0
          }
          this.onNetworkQualityArrOrigin = this.onNetworkQualityArrOrigin.map(item => {
            const { key } = item
            switch (key) {
              default:
                item.value = remoteVideoStatsObj[key]
                break
            }
            return item
          })
          // 以下只更新一次：
          if (updateCountForGetRemoteVideoStats === 0) {
            updateCountForGetRemoteVideoStats++
            this.onNetworkQualityArr = JSON.parse(JSON.stringify(this.onNetworkQualityArrOrigin))
          }
        })
      }, 1000)

      agora.enableAudioVolumeIndicator(evt => {
        let volume = 0
        if (evt.attr.length) {
          volume = evt.attr[0].level || 0
        } else {
          volume = 0
        }
        // this.barHeightForAudio = (volume * 15 > 100 ? 100 : volume * 15) + '%'
        // 教室列表的麦克风动态音量效果*2：
        this.barHeightForAudio = (volume * 15 > 100 ? 100 : volume * 15 * 2) + '%'
      })

      agora.watchStreamRemoved((e) => {
        console.log('视频流移除', e)
      })
      this.AbleRTC.get(this.classroomId).agoraClient.on('stream-added', (e) => {
        // console.log('stream-added', e.stream)
        let stream = e.stream
        agora.agoraClient.subscribe(
          stream,
          { video: true, audio: true },
          (err) => {
            console.log(err, '订阅失败subscribe')
          }
        )
      })
    },
    /**
     * @description: 获取状态机信息
     * @param {*}
     * @return {*}
     */
    async getStateMachine() {
      let res = await this.$http.getStateMachine({
        courseId: this.classroomId,
      })
      if (res.status != 200) {
        // return this.$message.error(res.data.rt.resultMessage)
        console.log('获取状态机数据失败')
        return
      }
      console.log('获取状态机数据成功', res.data)

      // 20220413 add zzg start:
      // 获取主讲：
      this.speakRoomCode = res.data.data.speakRoomCode
      // 默认主讲说话：
      this.whoIsSpeaking = this.speakRoomCode ? [this.speakRoomCode] : []
      // 20220413 add zzg end
      
      this.stateMachineArr = res.data
      this.currentStuRoomId = this.stateMachineArr.data.stuStreamRoomId
      await this.pageLogic()
    },
    /**
     * @description: 基于4006指令更新状态机信息
     * @param {*}
     * @return {*}
     */
    async getStateMachineBy4006() {
      let res = await this.$http.getStateMachine({
        courseId: this.classroomId,
      })
      if (res.status != 200) {
        console.log('获取状态机数据失败')
        return
      }
      this.stateMachineArr = res.data
      // 更新模式 基于4006指令
      this.nowModel = this.stateMachineArr.data.interactModel
      this.currentStuRoomId = this.stateMachineArr.data.stuStreamRoomId
      this.modelChange()
    },
    /**
     * @description: 通过liveId获取的直播信息：
     * @param {*}
     * @return {*}
     */
    async liveClassShareLive() {
      let { data: result } = await this.$http.liveClassShareLive({
        liveId: this.$route.query.liveId,
      })
      if (result.code !== 200) return reject(result.msg)
      this.liveClassShareLiveInfo = result.rt
    },
    // 获取im配置信息所需要的参数：
    async connectIm() {
      let { userId, status, liveType } = this.liveClassShareLiveInfo
      if (status === 0) status = 1
      let lcId = String(
        liveType == 2
          ? this.liveClassShareLiveInfo.mainLiveId
          : liveType == 1
          ? this.liveClassShareLiveInfo.id
          : ''
      )
      this.lcId = lcId
      this.Mutation_SET_USERID(userId)

      // 初始化IM:
      let { userId: managementUserId, liveId: mainLiveId } = this.$route.query
      if (status == 1 && lcId) {
        try {
          await this.getImConfigInfo({
            adminUserId: managementUserId,
            liveId: mainLiveId,
          })
          this.webImInit({
            lcId: this.lcId,
            cb: this.disposeMessage,
          })
        } catch (err) {
          this.$message.error(err)
        }
      }
    },
    /**
     * @description: 根据状态及消息添加需要订阅的流id以及其类型信息
     * @param {*}
     * @return {*}
     */
    async pageLogic() {
      this.nowModel = this.stateMachineArr.data.interactModel || 'T'
      this.stateMachineArr.data.users.forEach((item) => {
        if (item.role == 1) {
          this.teaVideoAudioRoomList.push(item)
          item.streamId.forEach((data) => {
            if (data.channelId == this.classroomId) {
              if (/v\/t/.test(data.streamType)) {
                data.type = 'video'
                data.position = 'teacher'
                this.teaVideoAndAudioStreamList.push(data)
              }
              if (/v\/s/.test(data.streamType)) {
                data.type = 'video'
                data.position = 'student'
                this.teaVideoAndAudioStreamList.push(data)
              }
              if (/v\/vga\/m/.test(data.streamType)) {
                data.type = 'video'
                data.position = 'course'
                this.teaVideoAndAudioStreamList.push(data)
              }
              if (/w\/a\/1/.test(data.streamType)) {
                data.type = 'audio'
                this.teaVideoAndAudioStreamList.push(data)
              }
            }
          })
        } else if (item.role == 2) {
          this.stuVideoAudioRoomList.push(item)
          item.streamId.forEach((data) => {
            if (data.channelId == this.classroomId) {
              data.roomId = item.roomId
              if (/v\/r\/l/.test(data.streamType)) {
                data.type = 'video'
                this.stuVideoAndAudioStreamList.push(data)
              } else if (/w\/a\/1/.test(data.streamType)) {
                data.type = 'audio'
                this.stuVideoAndAudioStreamList.push(data)
              }
            }
          })
        }
      })
      this.modelChange()
      // this.subscribeStream()
      // this.unsubcribeStream()
    },
    /**
     * @description: 根据全部流
     * @param {*}
     * @return {*}
     */
    subscribeStream() {
      this.AbleRTC.get(this.classroomId).watchStreamAdded((e) => {
        // console.log('订阅相应流', e)
      })
    },
    //  根据id取消订阅
    unsubcribeStream(streamId) {
      this.AbleRTC.get(this.classroomId).unsubscribeById(streamId)
    },
    /**
     * @description: 根据订阅成功的流和模式确定如何显示 保存状态
     * @param {*} streamData
     * @return {*}
     */
    showStream(streamData) {
      // teaVideoAudioRoomList: [], // 主讲订阅列表
      // stuVideoAudioRoomList: [], // 收视订阅列表
      // teaVideoAndAudioStreamList: [], // 主讲音视频流订阅
      // stuVideoAndAudioStreamList: [], // 收视音视频流订阅
      console.log('根据订阅成功的流和模式确定如何显示')
      // 收到主讲流
      this.teaVideoAndAudioStreamList.forEach((item, index) => {
        if (item.uuid == streamData.stream.streamId) {
          console.log('收到主讲流', item, streamData.stream.streamId)
          if (item.type == 'audio') {
            this.teaVideoAndAudioStreamList[index].audioStream =
              streamData.stream.stream
            // 其实下面的modelChange里面不需要再执行此方法 不过不会有重复的track推入 问题不大
            this.addAudiotoplay(streamData.stream.stream, item)
          } else if (item.type == 'video') {
            this.teaVideoAndAudioStreamList[index].videoStream =
              streamData.stream.stream
          }
        }
      })
      // 收到收视流
      this.stuVideoAndAudioStreamList.forEach((item, index) => {
        if (item.uuid == streamData.stream.streamId) {
          console.log('收到收视流', item, streamData.stream.streamId)
          if (item.type == 'audio') {
            this.stuVideoAndAudioStreamList[index].audioStream =
              streamData.stream.stream
            this.addAudiotoplay(streamData.stream.stream, item)
          } else if (item.type == 'video') {
            this.stuVideoAndAudioStreamList[index].videoStream =
              streamData.stream.stream
            this.$refs[`LCVideoViceRating${index}`][0].srcObject =
              streamData.stream.stream
          }
        }
      })
      this.modelChange()
    },
    /**
     * @description: 根据模式 显示左部大屏画面
     * @param {*}
     * @return {*}
     */
    async modelChange() {
      console.log('modelChange SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS', this.nowModel)
      this.$nextTick(() => {
      if (this.pageIsInit) {
        // 初始化第一次进入页面
        // 设置当前播放项为主讲
        this.currentPlayItem = this.teaVideoAudioRoomList[0]
      }
      switch (this.nowModel) {
        case 'T':
          {
            this.teaVideoAndAudioStreamList.forEach((item, index) => {
              if (item.type == 'audio') {
                this.addAudiotoplay(item.audioStream, item)
              } else if (item.type == 'video') {
                if (item.position == 'teacher') {
                  // 当右侧列表在主讲画面激活时 模式更改才会影响主画面 否则不切换
                  if (this.currentScreenModel == 'viceTeacher') {
                    if (
                      this.$refs.LCVideoMainLeft.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                    }
                  }
                  if (
                    this.$refs.LCVideoViceLeft.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                  }
                }
                if (item.position == 'course') {
                  if (
                    this.$refs.courseScreenRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.courseScreenRight.srcObject = item.videoStream
                  }
                }
              }
            })
            this.resetMainLeftHeight()
          }
          break
        case 'S':
          {
            // 如果 currentStuRoomId 不为空则从收视教室取画面 否则从主讲流拿学生画面
            if (this.currentStuRoomId) {
              this.teaVideoAndAudioStreamList.forEach((item, index) => {
                if (item.type == 'video') {
                  if (item.position == 'course') {
                    if (
                      this.$refs.courseScreenRight.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.courseScreenRight.srcObject = item.videoStream
                    }
                  }
                }
              })
                this.stuVideoAndAudioStreamList.forEach((item) => {
                  let streamTypeArr = item.streamType.split('/') || []
                  let roomId = streamTypeArr.length
                    ? streamTypeArr[streamTypeArr.length - 1]
                    : ''
                  if (this.currentScreenModel == 'viceTeacher') {
                    if (
                      roomId == this.stateMachineArr.data.stuStreamRoomId &&
                      item.type == 'video'
                    ) {
                      if (this.$refs.LCVideoMainLeft.srcObject?.id != item.uuid) {
                        this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                      }
                      if (this.$refs.LCVideoViceLeft.srcObject?.id != item.uuid) {
                        this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                      }
                    }
                  } else {
                    if (
                      roomId == this.stateMachineArr.data.stuStreamRoomId &&
                      item.type == 'video'
                    ) {
                      if (this.$refs.LCVideoViceLeft.srcObject?.id != item.uuid) {
                        this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                      }
                    }
                  }
                })
            } else {
              this.teaVideoAndAudioStreamList.forEach((item, index) => {
                if (item.type == 'audio') {
                  this.addAudiotoplay(item.audioStream, item)
                } else if (item.type == 'video') {
                  if (item.position == 'teacher') {
                    if (this.currentScreenModel == 'viceTeacher') {
                      if (
                        this.$refs.LCVideoMainLeft.srcObject?.id !=
                        item.videoStream?.id
                      ) {
                        this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                      }
                      if (
                        this.$refs.LCVideoViceLeft.srcObject?.id !=
                        item.videoStream?.id
                      ) {
                        this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                      }
                    }
                  }
                  if (item.position == 'student') {
                    // 当右侧列表在主讲画面激活时 模式更改才会影响主画面 否则不切换
                    if (this.currentScreenModel == 'viceTeacher') {
                      if (
                        this.$refs.LCVideoMainLeft.srcObject?.id !=
                        item.videoStream?.id
                      ) {
                        this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                      }
                    }
                    if (
                      this.$refs.LCVideoViceLeft.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                    }
                  }
                  if (item.position == 'course') {
                    if (
                      this.$refs.courseScreenRight.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.courseScreenRight.srcObject = item.videoStream
                    }
                  }
                }
              })
            }
            this.resetMainLeftHeight()
          }
          break
        case 'V':
          {
            this.teaVideoAndAudioStreamList.forEach((item, index) => {
              if (item.type == 'audio') {
                this.addAudiotoplay(item.audioStream, item)
              } else if (item.type == 'video') {
                // if (item.position == 'teacher') {
                //   if (this.currentScreenModel == 'viceTeacher') {
                //     if (
                //       this.$refs.LCVideoMainLeft.srcObject?.id !=
                //       item.videoStream?.id
                //       ) {
                //         this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                //     }
                //     if (
                //       this.$refs.LCVideoViceLeft.srcObject?.id !=
                //       item.videoStream?.id
                //     ) {
                //       this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                //     }
                //   }
                // }
                if (item.position == 'course') {
                  if (this.currentScreenModel == 'viceTeacher') {
                    if (
                      this.$refs.LCVideoMainLeft.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                    }
                  }
                }
                if (item.position == 'course') {
                  if (
                    this.$refs.LCVideoViceLeft.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                  }
                  if (
                    this.$refs.courseScreenRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.courseScreenRight.srcObject = item.videoStream
                  }
                }
              }
            })
            this.resetMainLeftHeight()
          }
          break
        case 'TS':
          {
            this.teaVideoAndAudioStreamList.forEach((item, index) => {
              if (item.type == 'audio') {
                this.addAudiotoplay(item.audioStream, item)
              } else if (item.type == 'video') {
                if (item.position == 'teacher') {
                  // 当右侧列表在主讲画面激活时 模式更改才会影响主画面 否则不切换
                  if (this.currentScreenModel == 'viceTeacher') {
                    if (
                      this.$refs.LCVideoMainLeft.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                    }
                  }
                  if (
                    this.$refs.LCVideoViceLeft.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                  }
                }
                // 当前是主讲时从主讲拿s的流 否则就从收视拿
                // item.position == 'student' && this.currentPlayItem == ''
                if (item.position == 'student') {
                  if (
                    this.$refs.LCVideoMainRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoMainRight.srcObject = item.videoStream
                  }
                  if (
                    this.$refs.LCVideoViceRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoViceRight.srcObject = item.videoStream
                  }
                }
                if (item.position == 'course') {
                  if (
                    this.$refs.courseScreenRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.courseScreenRight.srcObject = item.videoStream
                  }
                }
              }
            })
            if (this.currentStuRoomId != '') {
              this.stuVideoAndAudioStreamList.forEach((item) => {
                let streamTypeArr = item.streamType.split('/') || []
                let roomId = streamTypeArr.length
                  ? streamTypeArr[streamTypeArr.length - 1]
                  : ''
                if (roomId == this.currentStuRoomId && item.type == 'video') {
                  if (this.$refs.LCVideoMainRight.srcObject?.id != item.uuid) {
                    this.$refs.LCVideoMainRight.srcObject = item.videoStream
                  }
                  if (this.$refs.LCVideoViceRight.srcObject?.id != item.uuid) {
                    this.$refs.LCVideoViceRight.srcObject = item.videoStream
                  }
                }
              })
            } else if (this.stateMachineArr.data.stuStreamRoomId) {
              this.stuVideoAndAudioStreamList.forEach((item) => {
                let streamTypeArr = item.streamType.split('/') || []
                let roomId = streamTypeArr.length
                  ? streamTypeArr[streamTypeArr.length - 1]
                  : ''
                if (
                  roomId == this.stateMachineArr.data.stuStreamRoomId &&
                  item.type == 'video'
                ) {
                  if (this.$refs.LCVideoMainRight.srcObject?.id != item.uuid) {
                    this.$refs.LCVideoMainRight.srcObject = item.videoStream
                  }
                  if (this.$refs.LCVideoViceRight.srcObject?.id != item.uuid) {
                    this.$refs.LCVideoViceRight.srcObject = item.videoStream
                  }
                }
              })
            }

            this.resetMainLeftHeight()
          }
          break
        case 'TV':
          {
            this.teaVideoAndAudioStreamList.forEach((item, index) => {
              if (item.type == 'audio') {
                this.addAudiotoplay(item.audioStream, item)
              } else if (item.type == 'video') {
                if (item.position == 'teacher') {
                  // 当右侧列表在主讲画面激活时 模式更改才会影响主画面 否则不切换
                  if (this.currentScreenModel == 'viceTeacher') {
                    if (
                      this.$refs.LCVideoMainLeft.srcObject?.id !=
                      item.videoStream?.id
                    ) {
                      this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                    }
                  }
                  if (
                    this.$refs.LCVideoViceLeft.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoViceLeft.srcObject = item.videoStream
                  }
                }
                if (item.position == 'course') {
                  if (
                    this.$refs.LCVideoMainRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoMainRight.srcObject = item.videoStream
                  }
                  if (
                    this.$refs.LCVideoViceRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoViceRight.srcObject = item.videoStream
                  }
                }
                if (item.position == 'course') {
                  if (
                    this.$refs.courseScreenRight.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.courseScreenRight.srcObject = item.videoStream
                  }
                }
              }
            })
            this.setMainLeftTVHeight()
          }
          break
        default:
          break
      }
      if (this.currentScreenModel == 'viceStudent') {
        console.warn('viceStudent', this.currentScreenModel);
        this.teaVideoAndAudioStreamList.forEach((item, index) => {
          if (item.type == 'video') {
            if (item.position == 'student') {
              this.$refs.LCVideoMainLeft.srcObject = item.videoStream
            }
          }
        })
        this.stuVideoAndAudioStreamList.forEach((item) => {
          let streamTypeArr = item.streamType.split('/') || []
          let roomId = streamTypeArr.length
            ? streamTypeArr[streamTypeArr.length - 1]
            : ''
          if (
            item.type == 'video'
          ) {
            this.$refs.LCVideoMainLeft.srcObject = item.videoStream
          }
        })
      }
      // 不是第一次进入
      this.pageIsInit = false
      })
      // 处理自动播放：
      if (this.$refs.LCVideoMainLeft) {
        // console.log(this.$refs.LCVideoMainLeft, '可能需要处理自动播放')
        try {
          await this.$refs.LCVideoMainLeft.play()
          this.autoPlayError = false
        } catch (err) {
          console.log(err, 'autoplayError')
          // 需要弹出播放按钮：
          if (String(err).includes('first')) {
            this.autoPlayError = true
          } else {
            this.autoPlayError = false
          }
        }
      }
    },
    operationForPlay () {
      this.$refs.LCVideoMainLeft.play()
      this.autoPlayError = false
    },
    /**
     * @description: 点击侧边列表中正在播放的视频
     * @param {*}
     * @return {*}
     */
    selectCurrentScreen(type, viceIndex, data) {
      this.currentScreenModel = type
      this.viceIndex = viceIndex
      switch (type) {
        case 'viceTeacher':
          {
            this.modelChange()
            this.currentPlayItem = this.teaVideoAudioRoomList[0]
            if (this.nowModel == 'TV') {
              this.setMainLeftTVHeight()
            }
          }
          break
        case 'course':
          {
            this.teaVideoAndAudioStreamList.forEach((item, index) => {
              if (item.type == 'audio') {
              } else if (item.type == 'video') {
                if (item.position == 'course') {
                  if (
                    this.$refs.LCVideoMainLeft.srcObject?.id !=
                    item.videoStream?.id
                  ) {
                    this.$refs.LCVideoMainLeft.srcObject = item.videoStream
                  }
                }
              }
            })
            this.currentPlayItem = {
              className: '课件画面',
              role: 1,
            }
          }
          this.resetMainLeftHeight()
          break
        case 'viceStudent':
          {
            if (
              this.$refs.LCVideoMainLeft.srcObject?.id !=
              this.stuVideoAndAudioStreamList[viceIndex].videoStream?.id
            ) {
              this.$refs.LCVideoMainLeft.srcObject =
                this.stuVideoAndAudioStreamList[viceIndex].videoStream
            }
            this.currentPlayItem = this.stuVideoAudioRoomList.find(item => item.roomId == data.roomId) || {}
          }
          this.resetMainLeftHeight()
          break
        default:
          break
      }
    },
    // 新增audio标签并播放
    addAudiotoplay(remoteStream) {
      if (remoteStream == undefined) return
      // console.log('新增audio标签并播放')
      if (!this.totalAudioStream) {
        this.totalAudioStream = new MediaStream()
      }
      remoteStream.getAudioTracks().forEach((track) => {
        this.totalAudioStream.addTrack(track)
      })
      // remoteStream.getTracks().forEach((track) => {
      //   this.totalAudioStream.addTrack(track)
      // })
      // console.warn(
      //   remoteStream,
      //   this.totalAudioStream,
      //   this.totalAudioStream.getTracks()
      // )
      if (this.$refs.LCAudio) {
        this.$refs.LCAudio.srcObject = this.totalAudioStream
      }
    },
    /**
     * @description: 动态设置TV模式下左侧div的高度
     * @param {*}
     * @return {*}
     */
    setMainLeftTVHeight() {
      if (this.currentScreenModel != 'viceTeacher') {
        return
      }
      // .. 另一个盒子用flex: 1 自动撑开的 这个盒子竟然获取宽度不正确 style.width一直打印 50%
      // 因为用了flex:1 所以两个子盒子获取宽度都与实际不一致
      let mainVideoBoxDom = document.getElementsByClassName(
        'supervision_course_container_body_left_inner_for_class_of_outer'
      )[0]
      let mainVideoBoxDomWidth = mainVideoBoxDom.clientWidth
      let mainVideoBoxDomHeight = mainVideoBoxDom.clientHeight
      let mainRightDomWidth = (mainVideoBoxDomWidth / 4) * 3
      let mainRightDomHeight = (mainRightDomWidth / 16) * 9
      if (this.$refs.LCVideoMainLeft) {
        this.$refs.LCVideoMainLeft.style.height = mainRightDomHeight > mainVideoBoxDomHeight ? `${mainVideoBoxDomHeight}px` : `${mainRightDomHeight}px`
      }
    },
    /**
     * @description: 重置主画面高度
     * @param {*}
     * @return {*}
     */
    resetMainLeftHeight() {
      if (this.$refs.LCVideoMainLeft) {
        this.$refs.LCVideoMainLeft.style.height = `100%`
      }
    },
    // 处理收到消息：
    // 当前客户端类型
    // WXClient:微信小程序
    // WebClient:网页收视端
    // ANClient:安卓客户端
    // IOSClient：ios客户端
    async disposeMessage(data) {
      console.log('处理消息', data)
      let { type } = data
      console.log('type', type)
      switch (type) {
        //返回流信息给终端
        case '4001':
          // let joinStreamRoomList = data.data.streamInfo || []
          // // 设置当前正在播放的教室：
          // this.currentPlayItem = joinStreamRoomList[0]
          //   ? joinStreamRoomList[0]
          //   : null
          // // 设置教室列表：
          // this.videoList = joinStreamRoomList
          // if (this.currentPlayItem) {
          //   // 设置高亮选中效果：
          //   this.videoList = this.videoList.map((item) => {
          //     if (item.roomID === this.currentPlayItem.roomID) {
          //       item.active = true
          //     } else {
          //       item.active = false
          //     }
          //     // 同时设置发言状态：默认为主讲
          //     if (item.masterSpeaker) {
          //       item.speaking = true
          //     } else {
          //       item.speaking = false
          //     }
          //     return item
          //   })
          // }
          break
        // 发言：
        case '4003':
          let roomID = data.data.roomID
          this.whoIsSpeaking = roomID ? [roomID] : []
          break
        case '4033': // 双讲模式，发言教室集合
          // 展示谁在说话：
          {
            const roomIds = data.data.roomIds
            this.whoIsSpeaking = roomIds || []
          }
          break
        //下课 // 主讲下课
        case '4004':
        case '5004':
          this.$message.warning('下课了哦！')
          // 清空列表与当前播放教室：
          this.currentPlayItem = null
          // 重新获取直播信息：
          this.liveClassShareLiveInfo = null
          // setTimeout(async () => {
          //   await this.liveClassShareLive()
          // }, 500)
          setTimeout(() => {
            this.$router.replace({ name: 'LiveStreamingList' })
          }, 300)
          break
        case '4006':
          //4006指令
          // 督学切换模式
          this.getStateMachineBy4006()
          break
        //有教室退课
        case '4007':
        // 提示谁退课了：
        // let whoQuit = this.videoList.find(
        //   (item) => item.roomID === data.data.roomId
        // )
        // whoQuit && this.$message.warning(`${whoQuit.roomName}退课了哦！`)
        // // 设置更新之后的教室列表：
        // let newVideoList = this.videoList.filter(
        //   (item) => item.roomID !== data.data.roomId
        // )
        // this.videoList = newVideoList
        // // 设置更新之后的当前教室，如果退课的是正在播放的教室才会做处理
        // if (!this.currentPlayItem) return
        // if (this.currentPlayItem.roomID !== data.data.roomId) return
        // let currentPlayItem = this.videoList[0] || null
        // this.currentPlayItem = currentPlayItem
        // break
        //开启共享屏幕
        case '4008':
          break
        //关闭共享屏幕
        case '4009':
          // this.isJoined = false
          // this.showForCourseScreenInListOnRight = false
          // this.operationOfClickVideoListInnerItem(this.videoList[0])
          break
        case '4022':
          // 收到在线人数推送
          this.$bus.emit('roomOnlineNumChange', data.data.roomOnlineNum)
          break
        case '4023':
        // 后台告知客户端直播已经开始了，重新获取直播信息：
          await this.liveClassShareLive()
          this.liveDetailInfoForApp = await this.getLiveDetailForAPP(this.$route.query.liveId)
        break
        case '4025':
          // 新的聊天文本消息
          this.addIMMsg(data)
          if (this.getLeftBarName != 'textInteraction') {
            // 判断是否在文字互动界面
            if (data.data.uuid != `admin_${this.userInfo.userId}`) {
              // 不是自己的消息
              // 设置是有新消息提醒
              this.setIsHaveNewMsg(true)
            }
          }
          break
        case '4027':
          // 禁言解禁消息
          this.$bus.emit('forbidUserChange', data)
          break
        case '4035':
          this.setRoleList(data.data.teacherUuids)
          break
        // 收视教室加入
        case '5002':
          this.getStateMachineForStu()
          break
        // 收视退出
        case '5007':
          // 删除这个收视教室
          this.deleteStuVideoBy5007(data.data)
          break
      }
    },
    /**
     * @description: 获取状态机信息 添加收视教室
     * @param {*}
     * @return {*}
     */
    async getStateMachineForStu() {
      let res = await this.$http.getStateMachine({
        courseId: this.classroomId,
      })
      if (res.status != 200) {
        console.log('获取状态机数据失败')
        return
      }
      // console.log('获取状态机数据成功', res.data)
      this.stateMachineArr = res.data
      this.stateMachineArr.data.users.forEach((item) => {
        if (item.role == 2) {
          let isHaveIndex = this.stuVideoAudioRoomList.findIndex(
            (room) => room.roomId == item.roomId
          )
          if (isHaveIndex == -1) {
            this.stuVideoAudioRoomList.push(item)
            item.streamId.forEach((data) => {
              if (data.channelId == this.classroomId) {
                if (/v\/r\/l/.test(data.streamType)) {
                  data.type = 'video'
                  this.stuVideoAndAudioStreamList.push(data)
                } else if (/w\/a\/1/.test(data.streamType)) {
                  data.type = 'audio'
                  this.stuVideoAndAudioStreamList.push(data)
                }
              }
            })
          }
        }
      })
    },
    /**
     * @description: 删除5007指令下的收视教室
     * @param {*}
     * @return {*}
     */
    deleteStuVideoBy5007(data) {
      let { roomId } = data
      let uuids = []
      let index = this.stuVideoAudioRoomList.findIndex((item) => {
        return item.roomId == roomId
      })
      if (index != -1) {
        this.stuVideoAudioRoomList[index].streamId?.forEach((item) => {
          uuids.push(item.uuid)
        })
        this.stuVideoAudioRoomList.splice(index, 1)
        if (uuids.length) {
          uuids.forEach((uuid) => {
            let streamIndex = this.stuVideoAndAudioStreamList.findIndex(
              (item) => {
                return uuids.includes(item.uuid)
              }
            )
            if (streamIndex != -1) {
              this.stuVideoAndAudioStreamList.splice(streamIndex, 1)
            }
          })
        }
      }
      // 如果收视教室是当前教室 那么指定主讲画面为主画面
      if (roomId == this.currentPlayItem.rooId) {
        this.selectCurrentScreen('viceTeacher')
      }
    },
    // 判断按钮点击事件  课程-教室详情  终止直播
    operationOfClickButton(item) {
      if (item.disabled) return
      const { key } = item
      if (item.key === this.activeForOperationItem) {
        this.activeForOperationItem = ''
      } else {
        this.activeForOperationItem = key
      }
      switch (key) {
        case 'classroom':
          // this.dialogFlagForLCDetail = true;
          break
        case 'adjust':
          console.log('调整相应教室的机位')
          break
        case 'textInteraction':
          break
        case 'termination':
          this.dialogFlagForStopLiveCourse = true
          break
      }
    },
    // hideMaskForLCDetail() {
    //   this.dialogFlagForLCDetail = false
    // },
    // getDetail:  课程-教室详情按钮
    async getLCDetail(liveId) {
      try {
        this.dialogLoadingForLCDetail = true
        let result = await this.$http.getLiveDetail({ liveId })
        this.dialogLoadingForLCDetail = false
        if (result.code !== 200) return this.$message.error(result.msg)
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(
            resultReally.resultMessage
              ? resultReally.resultMessage
              : '获取详情失败'
          )
        let { liveInfo } = resultReally
        let detailInfoList = JSON.parse(
          JSON.stringify(this.objectOfLCDetail.detailInfoList)
        )
        this.objectOfLCDetail.detailInfoList = detailInfoList.map((item) => {
          let { title } = item
          switch (title) {
            case '课程':
              item.firstValue = liveInfo.courseName
                ? liveInfo.courseName
                : '- -'
              // item.secondValue = liveInfo.liveCode
              //   ? `ID：${liveInfo.liveCode}`
              //   : '- -'
              // // 20220411 add zzg start:
              // if (liveInfo.liveCourseId) {
              //   item.secondValue += `；LC：${liveInfo.liveCourseId}`
              // }
              // // 20220411 add zzg end
              // 最新修改：
              // 有lcid就用lcid：
              item.secondValue = liveInfo.liveCourseId ? `ID：${liveInfo.liveCourseId}` : '- -'
              if (!item.secondValue) item.secondValue = liveInfo.liveCode ? `ID：${liveInfo.liveCode}` : '- -'
              break
            case '类型':
              item.secondValue = `${
                liveInfo.roomNum ? liveInfo.roomNum : 0
              }间教室`
              break
            case '主讲':
              item.firstValue = liveInfo.teacherName
                ? liveInfo.teacherName
                : '- -'
              item.secondValue = liveInfo.teacherPhone
                ? liveInfo.teacherPhone
                : '- -'
              break
            case '时间':
              let startTime = liveInfo.startTime
                ? DateUtil.getTimeForDate(liveInfo.startTime)
                : ''
              let endTime = liveInfo.endTime
                ? DateUtil.getTimeForDate(liveInfo.endTime)
                : ''
              let res = `${startTime}-${endTime}`
              if (startTime && endTime) {
                if (startTime.split(' ')[0] === endTime.split(' ')[0]) {
                  let arr = startTime.split(' ')[0].split('-')
                  let arrForTimeForStart = startTime.split(' ')[1].split(':')
                  let arrForTimeForEnd = endTime.split(' ')[1].split(':')
                  res =
                    arr[0] +
                    '年' +
                    arr[1] +
                    '月' +
                    arr[2] +
                    '日 ' +
                    arrForTimeForStart[0] +
                    ':' +
                    arrForTimeForStart[1] +
                    '-' +
                    arrForTimeForEnd[0] +
                    ':' +
                    arrForTimeForEnd[1]
                }
              }
              item.firstValue = res
              break
          }
          return item
        })
        let teachRoomList = resultReally.teachRoom
          ? [{ ...resultReally.teachRoom, roomType: 1 }]
          : []
        let watchRoomList = (resultReally.watchRoom || []).map((item) => {
          return {
            ...item,
            roomType: 2,
          }
        })
        this.objectOfLCDetail.roomList = [...teachRoomList, ...watchRoomList]

      } catch (err) {
        console.log(err)
      }
    },
    hideMaskForStopLiveCourse() {
      this.dialogFlagForStopLiveCourse = false
    },
    operationForStopLiveCourseItem(stopLiveCourseOperationItem) {
      let { title } = stopLiveCourseOperationItem
      switch (title) {
        case '继续终止':
          this.stopLiveCourseContinue()
          break
        case '撤销操作':
          this.hideMaskForStopLiveCourse()
          this.stopReason = ''
          this.setForActiveForOperationItem('')
          break
      }
    },
    // 继续终止：
    async stopLiveCourseContinue() {
      try {
        if (!this.stopReason) {
          // 设置抖动：
          this.stopReasonHasAnimateShakeX = true
          setTimeout(() => {
            this.stopReasonHasAnimateShakeX = false
          }, 500)
          return this.$message.warning('请输入终止直播的原因')
        }
        // 与后端讨论该传啥：
        let { liveId } = this.$route.query
        let params = {
          mainLiveId: liveId,
          reason: this.stopReason,
        }
        this.dialogLoadingForStopLiveCourse = true
        let result = await this.$http.stopLive(params)
        this.dialogLoadingForStopLiveCourse = false
        if (result.code !== 200) return this.$message.error(result.msg)
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(
            resultReally.resultMessage
              ? resultReally.resultMessage
              : '终止直播失败'
          )
        // 需要通过终止的类型（是下课还是退课），进而跳转至相应的页面
        this.$message.success('终止直播成功')
        this.hideMaskForStopLiveCourse()
        this.stopReason = ''
        this.setForActiveForOperationItem('')
        // code： 1下课，2退课
        // 针对下课还是上课，这里不用做判断了，因为会发指令，4004或者4007
      } catch (err) {
        console.log(err)
      }
    },
    setForActiveForOperationItem (key) {
      this.activeForOperationItem = key
    },
    lookForNetworkInfo() {
      this.networkInfoShow = !this.networkInfoShow
    },
    // 设置球控不可操作：
    disposeForAdjustDisabled (flagForDisabled) {
      this.operationList = this.operationList.map(item => {
        const { key } = item
        if (key === 'adjust') {
          item.img = flagForDisabled ? 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/f8b4052cf0734d849c9e25e0271adb34.png' : 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/20c97caea47a443e87fb7df90a590137.png'
          item.color = flagForDisabled ? '#555B62 ' : '#FFF'
          item.disabled = flagForDisabled
        }
        return item
      })
    },
    ZRTCInit() {
      return new Promise(async (resolve) => {
        // 1、设置环境变量：
        // ZRTC.env('test') // 'test' | 'preproduction' | 'production'
        console.log(this.lcId, 'current_liveId')
        const client = ZRTC.init(this.lcId)
        client.setClientRole('audience')
        console.log(this.stateMachineArr, 'this.stateMachineArrthis.stateMachineArr')
        const roomId = this.stateMachineArr.data.users[0].roomId
        try {
          // await client.joinRoom(this.lcId, this.userId, roomId)
          // console.log(this.userId, this.lcId, roomId, 'userId + liveId + roomId')
          // 新版本只需要两个参数：
          // console.log(roomId, this.userId, 'roomId + userId')
          // await client.joinRoom(roomId, this.userId)
          console.log(roomId, new Date().getTime(), 'roomId + userId')
          await client.joinRoom(roomId, new Date().getTime())
          // 加入房间使用当前页面的：
          // console.log(roomId, this.$route.query.userId, 'roomId + userId')
          // await client.joinRoom(roomId, this.$route.query.userId)
          console.log('joinRoom success')
          resolve(client)
        } catch (err) {
          console.log(err, 'joinRoom_err')
          return this.$message.error(
            '抱歉，当前加入直播人数已达上限，无法加入！'
          )
        }
      })
    },
    async getMicStatus () {
      // 初始化：
      let client = null
      if (!this.clientForZRTC) {
        client = await this.ZRTCInit()
        this.clientForZRTC = client
      } else {
        client = this.clientForZRTC
      }
      console.log(client, 'clientclientclientclient')
      // 获取在麦状态：
      client.onGetMicStatus(data => {
        console.log(data, 'onGetMicStatus_data')
        // console.log(data.responseData, 'data.responseData')
        console.log(data.responseData.content || [], 'data.responseData.content')
        if (data.responseData && data.responseData.content || []) {
          const roomIds = (data.responseData.content || []).filter(item => item.voice).map(item => item.roomid)
          this.whoIsSpeaking = roomIds
        }
      })
    },
    // 添加调试中这个状态，所以需要获取新的详情：
    getLiveDetailForAPP(liveId) {
      return new Promise(async (resolve, reject) => {
        try {
          const result = await this.$http.getLiveDetailForAPP({ liveId })
          if (result.code !== 200) return reject(result.msg)
          const { rt: resultReally } = result
          if (resultReally.resultStatus !== 1) return this.$message.error(resultReally.resultMessage)
          resolve(result.rt)
        } catch (err) {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.supervision_course_container {
  width: 100%;
  height: 100vh;
  background-color: #000;
  position: relative;
  // background-image: radial-gradient(
  //   at center top,
  //   rgba(82, 135, 233, 0.8) -400px,
  //   #000000 400px
  // );
  text-align: left;
  display: flex;
  flex-direction: column;

  .supervision_course_container_header {
    width: 100%;
    height: 100px;
    background-color: #0F111C;
    position: relative;
    border-bottom: 2px solid #090d1b;
    .supervision_course_container_header_status_and_time {
      width: auto;
      height: 50px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .supervision_course_container_header_title_module {
      width: 600px;
      height: 100px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
      // width: 600px;
      // height: auto;
      // padding: 30px 0 20px;
      // display: flex;
      // flex-direction: column;
      // .supervision_course_container_header_title_module_top {
      //   width: 100%;
      //   height: auto;
      //   .supervision_course_container_header_title_module_top_inner {
      //     display: flex;
      //     align-items: center;
      //     justify-content: center;
      //     .supervision_course_container_header_title_module_top_img {
      //       width: 75px;
      //       height: 45px;
      //       margin-right: 20px;
      //       img {
      //         width: 100%;
      //         height: 100%;
      //         display: block;
      //       }
      //     }
      //     .supervision_course_container_header_title_module_top_text {
      //       span {
      //         &:nth-of-type(1) {
      //           font-size: 50px;
      //           font-weight: 800;
      //           color: #5f98ff;
      //         }
      //         &:nth-of-type(2) {
      //           font-size: 50px;
      //           font-weight: 400;
      //           color: #fff;
      //         }
      //       }
      //     }
      //   }
      // }
      // .supervision_course_container_header_title_module_bottom {
      //   width: 100%;
      //   height: 10px;
      //   display: flex;
      //   justify-content: center;
      //   margin-top: 5px;
      //   .line {
      //     width: 500px;
      //     height: 2px;
      //     background: linear-gradient(
      //       244deg,
      //       rgba(255, 255, 255, 0) 0%,
      //       rgba(82, 135, 233, 0.7) 50%,
      //       rgba(255, 255, 255, 0) 100%
      //     );
      //   }
      // }
    }
    .supervision_course_container_header_right_module {
      width: auto;
      height: inherit;
      padding: 0 16px;
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
    }
  }
  .supervision_course_container_body {
    width: 100%;
    height: calc(100vh - 166px);
    background-color: #0b1321;
    display: flex;
    padding: 16px 0;
    position: relative;
    .supervision_course_container_body_left_inner_for_class_of_outer_tsbgimg {
      background-image: url('../../assets/img/ts-bg.jpg');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .supervision_course_container_body_left {
      flex: 1;
      margin-left: 16px;
      position: relative;
      .supervision_course_container_body_left_inner_for_screen_stream,
      .supervision_course_container_body_left_inner_for_class_of_outer {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #000;
        display: flex;
      }
      .supervision_course_container_body_left_inner_for_screen_stream {
        #idForCourseScreenOnLeft {
          width: 100% !important;
          height: 100% !important;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .supervision_course_container_body_left_inner_for_class_of_outer {
        @include verticalAndCrosswiseCenter();
        display: flex;
        .supervision_course_container_body_left_inner_for_class_of_outer_video {
          width: 50%;
          height: 100%;
          position: relative;
          video {
            width: 100%;
            height: 100%;
          }
        }
        > div:nth-child(1) {
          flex: 1;
          display: flex;
          align-items: center;
        }
        /* >div:nth-child(2){
          width: 50%;
        } */
        .supervision_course_container_body_left_inner_for_class_of_outer_video_full_screen {
          width: 100%;
          height: 100%;
          position: relative;
        }
      }
      .play_explain_for_box {
        position: absolute;
        bottom: 0px;
        left: 0px;
        font-size: 16px;
        padding: 0 16px;
        color: #fff;
        z-index: 2;
        width: 100%;
        height: 56px;
        line-height: 56px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
      }
      .video_empty_container {
        @include verticalAndCrosswiseCenter();
        flex-direction: column;
        font-size: 16px;
        color: #aaa;
        user-select: none;
      }
      // // 修改视频播放器的样式：
      // ::v-deep.video-wrapper .alt {
      //   background-color: #222 !important;
      //   border-radius: 10px;
      // }
      // .video-js {
      //   background-color: #222;
      //   border-radius: 10px;
      // }
      // ::v-deep.vjs-control-bar {
      //   z-index: 3;
      // }
    }
    .supervision_course_container_body_right {
      width: 320px;
      height: 100%;
      position: relative;
      overflow: hidden;
      .supervision_course_container_body_right_for_video {
        width: calc(100% + 30px);
        height: 100%;
        padding: 0 16px;
        overflow-y: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      video {
        object-fit: cover;
      }
      .supervision_course_container_body_right_inner_item {
        width: 288px;
        height: 162px;
        margin-bottom: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        overflow: hidden;
        position: relative;
        border-radius: 6px;
        background-color: #000;
        &:nth-last-child(1) {
          margin-bottom: 0px;
        }
        &.active {
          border: 3px solid #fb6f33;
        }
        > div:nth-child(1) {
          flex: 1;
        }
        .supervision_course_container_body_right_inner_item_for_video {
          /* width: 50%; */
          height: 100%;
          position: relative;
          video {
            width: 100%;
            height: 100%;
          }
          &.course_screen_in_list_on_right_outer {
            #idForCourseScreenInListOnRight {
              width: 100% !important;
              height: 100% !important;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              object-fit: fill;
            }
          }
        }
        .play_explain_for_box {
          position: absolute;
          bottom: 0px;
          left: 0px;
          font-size: 14px;
          padding: 0 12px;
          color: #fff;
          width: 100%;
          height: 36px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .speaking_toast {
          width: 80px;
          height: 30px;
          background: #fb6f33;
          border-radius: 0px 130px 130px 0px;
          opacity: 0.6;
          font-size: 14px;
          color: #ffffff;
          display: flex;
          justify-content: flex-start;
          padding-left: 5px;
          align-items: center;
          position: absolute;
          left: 0;
          top: 10px;
        }
      }
      .live_detail_container {
        width: 308px;
        height: calc(100% + 16px);
        background-color: #0E111C;
        position: absolute;
        right: 0;
        top: -16px;
        color: #fff;
        padding: 12px 14px;
        overflow-y: auto;
        .live_detail_container_title {
          width: 100%;
          height: 60px;
          line-height: 65px;
          border-bottom: 1px solid #424653;
          font-weight: bold;
        }
        .live_detail_container_base_info_title,
        .live_detail_container_for_teacher_title,
        .live_detail_container_for_student_title {
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          padding-left: 8px;
          position: relative;
          margin-top: 10px;
          &:before {
            content: '';
            width: 3px;
            height: 16px;
            background-color: #3a82ff;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .live_detail_container_base_info {
          color: #ececed;
          border-bottom: 1px solid #424653;
          .live_detail_container_base_info_title {
          }
          .live_detail_container_base_info_body {
            padding: 10px;
            padding-top: 0px;
            font-size: 12px;
            .live_detail_container_base_info_body_item {
              display: flex;
              align-items: center;
              padding: 5px 0;
              .live_detail_container_base_info_body_item_title {
              }
              .live_detail_container_base_info_body_item_body {
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
        .live_detail_container_for_teacher {
          margin-bottom: 20px;
          color: #ececed;
          .live_detail_container_for_teacher_title {
            margin-bottom: 10px;
          }
          .live_detail_container_for_teacher_body {
            width: 100%;
            height: auto;
            background-color: #223961;
            border-radius: 5px;
            padding: 10px;
          }
        }
        .live_detail_container_for_student {
          .live_detail_container_for_student_title {
            margin-bottom: 10px;
          }
          .live_detail_container_for_student_body {
            width: 100%;
            height: auto;
            background-color: #223961;
            border-radius: 5px;
            padding: 10px;
          }
        }
        .body_item {
          &.body_item_for_student {
            margin-bottom: 20px;
          }
          &.body_item_for_student:nth-last-of-type(1) {
            margin-bottom: 0;
          }
          .body_item_title {
            font-size: 14px;
          }
          .body_item_body {
            font-size: 12px;
            .body_item_body_management,
            .body_item_body_maintain {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin: 5px 0;
            }
            .body_item_body_management {
            }
            .body_item_body_maintain {
              margin-bottom: 0;
            }
          }
        }
        .live_detail_container_for_teacher_body_empty,
        .live_detail_container_for_student_body_empty {
          width: 100%;
          height: 50px;
          background-color: #223961;
          border-radius: 5px;
          @include verticalAndCrosswiseCenter();
          color: #AAA;
          font-size: 14px;
        }
      }
      .textInteraction_container {
        width: 308px;
        height: 100%;
        background-color: #0E111C;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .supervision_course_container_body_right_top_module {
      width: 308px;
      height: 16px;
      background-color: #0E111C;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .supervision_course_container_footer {
    width: 100%;
    height: 66px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #0F111C;
    .supervision_course_container_footer_left_for_name {
      font-size: 20px;
      padding-left: 25px;
    }
    .supervision_course_container_footer_right_for_operation {
      display: flex;
      width: auto;
      height: 100%;
      padding-right: 16px;
      .supervision_course_container_footer_right_for_operation_item {
        width: 88px;
        height: 100%;
        cursor: pointer;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &.class_for_disabled {
          cursor: not-allowed;
          &:hover {
            background-color: #0F111C;
          }
          &.active {
            background-color: #0F111C;
          }
        }
        .iconfont_icon {
          width: 24px;
          height: 24px;
          display: block;
        }
        .iconfont_text {
          margin-top: 3px;
        }
        &:hover {
          background-color: #2c3038;
        }
        &.active {
          background-color: #2c3038;
        }
      }
    }
  }
}
.empty_for_class_rooom_list {
  width: 100%;
  height: 100%;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  flex-direction: column;
  .iconfont {
    font-size: 50px;
    margin-bottom: 10px;
  }
}
// 终止直播：
.dialog_inner_container_for_stop_live_course {
  position: relative;
  .dialog_inner_container_for_stop_live_course_header {
    @include dialogTitle(#fe7c14);
    text-align: center;
    border-bottom: none;
    background-color: #353744;
    line-height: 70px;
    font-size: 20px;
    border-radius: 8px 8px 0 0;
  }
  .dialog_inner_container_for_stop_live_course_body {
    padding: 5px 35px 24px;
    background-color: #353744;
    .dialog_inner_container_for_stop_live_course_body_title {
      font-size: 14px;
      color: #D3D4D7;
    }
    .dialog_inner_container_for_stop_live_course_body_content {
      width: 100%;
      height: 130px;
      border: 1px solid #3B7AEE;
      border-radius: 8px;
      margin-top: 20px;
      padding: 16px;
      background-color: #484A56;
      textarea {
        width: 100%;
        height: 100% !important;
        border: none;
        outline: none;
        resize: none;
        background-color: #484A56;
        color: #8D8FA0;
        font-size: 12px;
        color: #FFF;
      }
      // 改变placeholder的颜色：兼容性处理
      textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
      textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
      textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
      textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
    }
  }
  .dialog_inner_container_for_stop_live_course_footer {
    display: flex;
    padding: 0 35px;
    padding-bottom: 64px;
    justify-content: space-between;
    background-color: #353744;
    border-radius: 0 0 8px 8px;
    .dialog_inner_container_for_stop_live_course_footer_inner_item {
      width: 152px;
      height: 44px;
      @include verticalAndCrosswiseCenter();
      border-radius: 8px;
      cursor: pointer;
      user-select: none;
      &.stop_live_course_continue {
        &:hover {
          background-color: rgba(255, 255, 255, .1) !important;
        }
        &:active {
          background-color: transparent !important;
        }
      }
      &.stop_live_course_cancel {
        box-shadow: #3982FF;
        &:hover {
          background-color: #2563ce !important;
        }
        &:active {
          background-color: #3982FF !important;
        }
      }
    }
  }
}
.loading_mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  @include verticalAndCrosswiseCenter();
  background-color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}
// .data_on_network_quality_container {
//   width: 600px;
//   height: auto;
//   box-shadow: 1px 1px 8px #DDD;
//   background-color: rgba(0, 0, 0, 0.5);
//   position: absolute;
//   top: 20px;
//   left: 20px;
//   border-radius: 10px;
//   padding: 10px;
//   color: #DDD;
//   z-index: 99;
//   .data_on_network_quality_container_inner_title {
//     width: 100%;
//     height: 40px;
//     font-weight: bold;
//     line-height: 40px;
//     border-bottom: 1px dotted #DDD;
//   }
//   .data_on_network_quality_container_inner_item {
//     width: 100%;
//     padding: 5px 0;
//   }
//   .data_on_network_quality_container_null {
//     width: 100%;
//     height: 50px;
//     @include verticalAndCrosswiseCenter();
//     color: #DDD;
//   }
// }
</style>
